import React from 'react';


const UserInfoPanel = ({ user }) => {
  if (!user) return null;

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-tier-1">
      <div className="flex flex-col md:flex-row gap-6">
        {/* User Avatar and Basic Info */}
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0">
            <img 
              src={user?.avatar} 
              alt={user?.name}
              className="w-full h-full object-cover"
            />
          </div>
          <div>
            <h2 className="text-xl font-heading font-semibold text-foreground">
              {user?.name}
            </h2>
            <p className="text-secondary font-medium">
              {user?.title}
            </p>
            <div className="flex items-center gap-4 mt-2">
              <div className="flex items-center gap-1">
                <svg className="w-4 h-4 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <span className="text-sm font-medium text-foreground">{user?.rating}</span>
              </div>
              <div className="text-sm text-muted-foreground">
                {user?.totalSessions} atendimentos
              </div>
            </div>
          </div>
        </div>

        {/* Professional Info */}
        <div className="flex-1 space-y-4">
          {/* Bio */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-2">Sobre</h4>
            <p className="text-sm text-muted-foreground">
              {user?.bio}
            </p>
          </div>

          {/* Specialties */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-2">Especialidades</h4>
            <div className="flex flex-wrap gap-2">
              {user?.specialties?.map((specialty, index) => (
                <span 
                  key={index}
                  className="px-2 py-1 bg-secondary/10 text-secondary text-xs rounded-full border border-secondary/20"
                >
                  {specialty}
                </span>
              ))}
            </div>
          </div>

          {/* Availability */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-2">Disponibilidade Geral</h4>
            <div className="flex items-center gap-2">
              <svg className="w-4 h-4 text-success" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-sm text-muted-foreground">{user?.availability}</span>
            </div>
          </div>
        </div>

        {/* Quick Stats */}
        <div className="md:w-48 space-y-3">
          <div className="text-center p-3 bg-accent/10 rounded-lg">
            <div className="text-2xl font-bold text-accent">{user?.totalSessions}</div>
            <div className="text-xs text-muted-foreground">Atendimentos</div>
          </div>
          <div className="text-center p-3 bg-success/10 rounded-lg">
            <div className="text-2xl font-bold text-success">{user?.rating}</div>
            <div className="text-xs text-muted-foreground">Avaliação</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserInfoPanel;